<template>
  <li class="kp-logo" :title="$t('general.labels.homepage')">
    <router-link :to="{ name: 'index', params: { locale: i18n.locale } }">
      <img src="../../../../../assets/hotmart-logo.svg" :alt="$t('general.labels.hotmart_logo')">
    </router-link>
  </li>
</template>

<script>
  import i18n from '../../../../../i18n';

  export default {
    data() {
      return {
        i18n,
      };
    },
  };
</script>



/** WEBPACK FOOTER **
 ** Logo.vue?6416eeed
 **/